import type { IUIKitSurface } from './IUIKitSurface';
import { UIKitSurfaceType } from './IUIKitSurface';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export import UIKitViewType = UIKitSurfaceType;
// Added for backwards compatibility
export type IUIKitView = IUIKitSurface;
